import React from 'react';

export const Row = ({ children, style = {}, ...props }: any) => (
    <div style={{ display: 'flex', alignItems: 'center', ...style }} {...props}>{children}</div>
);

export const Col = ({ children, style = {}, ...props }: any) => (
    <div style={{ display: 'flex', flexDirection: 'column', ...style }} {...props}>{children}</div>
);
